module.exports = __webpack_public_path__ + "static/media/dayoungx2c2p.9558d4e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/dayoungx2c2p.png
// module id = 505
// module chunks = 0